import { apiFetch } from '../client';

export function fetchUserAdData() {
    return apiFetch('/user-api/get-ad-data/', {method: 'GET'})
}

export function getUserData() {
    return apiFetch('/user-api/data/', {method: 'GET'})
}